import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useLpEventsStore } from 'src/store/benefits/lp-events.store';

export default function useLPEventsList() {
  const navigate = useNavigate();
  const { getLpEventsList, lpEventsList, isLoadingLpEventsList } = useLpEventsStore();

  const TABLEHEADER = [
    { id: 'name', label: 'Nome' },
    { id: 'startDate', label: 'Data de Início', type: 'dateOnly' },
    { id: 'endDate', label: 'Data de Fim', type: 'dateOnly' },
    { id: 'editedBy.name', label: 'Atualizado por' },
    { id: 'editedAt', label: 'Atualizado em', type: 'dateOnly' },
    { id: 'status', label: 'Status', type: 'label' },
  ];

  useEffect(() => {
    const fetchLpEventsList = async () => {
      try {
        await getLpEventsList();
      } catch (error) {
        console.error('Error fetching LP events list:', error);
      }
    };

    fetchLpEventsList();
  }, []);

  const auxLpEventsList = lpEventsList.map(event => ({
    ...event,
    editedAt: event.editedAt ? event.editedAt : '-',
  }));

  return {
    TABLEHEADER,
    isLoadingLpEventsList,
    lpEventsList: auxLpEventsList,
    navigate,
  };
}
